/** Clear transient feedback from every review step in this editor. */
export const useClearInstanceErrors = (editorRoot: ParentNode) => {
  const elements = editorRoot.querySelectorAll(".instance-error");
  for (const element of elements) {
    element.classList.remove("instance-error");
  }
};
